import { render, staticRenderFns } from "./RatingWidget.vue?vue&type=template&id=56aa0eae&scoped=true"
import script from "./RatingWidget.vue?vue&type=script&lang=js"
export * from "./RatingWidget.vue?vue&type=script&lang=js"
import style0 from "./RatingWidget.vue?vue&type=style&index=0&id=56aa0eae&prod&scoped=true&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "56aa0eae",
  null
  
)

export default component.exports